import { render, staticRenderFns } from "./TheApprovalPanel.vue?vue&type=template&id=10182faa&scoped=true"
import script from "./TheApprovalPanel.vue?vue&type=script&lang=js"
export * from "./TheApprovalPanel.vue?vue&type=script&lang=js"
import style0 from "./TheApprovalPanel.vue?vue&type=style&index=0&id=10182faa&prod&lang=scss"
import style1 from "./TheApprovalPanel.vue?vue&type=style&index=1&id=10182faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10182faa",
  null
  
)

export default component.exports